/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { i as initialize } from './ionic-global-CDrldh-5.js';

const globalScripts = initialize;

export { globalScripts as g };
